import { baseApi } from "./base.api";

export const patientsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchPatients: build.query({
      query: (params) => ({ url: "/patients/fetch", method: "GET", params }),
      providesTags: ["Patient"],
    }),
    fetchTrashedPatients: build.query({
      query: (params) => ({ url: "/patients/fetch/trashed", method: "GET", params }),
      providesTags: ["Patient"],
    }),
    fetchPatientsAll: build.query({
      query: () => ({ url: "/patients/fetch/all", method: "GET" }),
      providesTags: ["Patient"],
    }),
    fetchPhysiciansAll: build.query({
      query: (unit_id) => ({ url: `/patients/all/physicians/${unit_id}`, method: "GET" }),
      providesTags: ["Patient"],
    }),
    fetchPatientById: build.query({
      query: (id) => ({ url: `/patients/fetch/${id}`, method: "GET" }),
      providesTags: ["Patient"],
    }),
    fetchPatientByTracking: build.mutation({
      query: (body) => ({ url: `/patients/fetch/by/tracking`, method: "POST", body }),
      providesTags: ["Patient"],
    }),
    createPatient: build.mutation({
      query: (body) => ({ url: "/patients/create", method: "POST", body }),
      invalidatesTags: ["Patient"],
    }),
    updatePatient: build.mutation({
      query: ({ id, body }) => ({ url: `/patients/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["Patient"],
    }),
    restorePatient: build.mutation({
      query: (id) => ({ url: `/patients/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["Patient"],
    }),
    bulkRestorePatients: build.mutation({
      query: (body) => ({ url: "/patients/bulk-restore", method: "POST", body }),
      invalidatesTags: ["Patient"],
    }),
    deletePatient: build.mutation({
      query: (id) => ({ url: `/patients/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["Patient"],
    }),
    bulkDeletePatients: build.mutation({
      query: (body) => ({ url: "/patients/bulk-delete", method: "POST", body }),
      invalidatesTags: ["Patient"],
    }),
    destroyPatient: build.mutation({
      query: (id) => ({ url: `/patients/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["Patient"],
    }),
    bulkDestroyPatients: build.mutation({
      query: (body) => ({ url: "/patients/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["Patient"],
    }),
  }),
});

export const {
  useFetchPatientsQuery,
  useFetchTrashedPatientsQuery,
  useFetchPatientByIdQuery,
  useCreatePatientMutation,
  useUpdatePatientMutation,
  useRestorePatientMutation,
  useBulkRestorePatientsMutation,
  useDeletePatientMutation,
  useFetchPatientsAllQuery,
  useBulkDeletePatientsMutation,
  useFetchPhysiciansAllQuery,
  useDestroyPatientMutation,
  useFetchPatientByTrackingMutation,
  useBulkDestroyPatientsMutation,
} = patientsApi;
